import React, {useState} from 'react';
import {Navigate} from 'react-router-dom'

import logo from '../../assets/DiagoRisk/DiagoRisk-logoRVB.png'
import entete_accueil from '../../assets/Site_Web/entete_accueil.png'
import vitiPlus2 from '../../assets/Site_Web/carte+2°.png'
import secutransi from '../../assets/Site_Web/secu_vos_transitions.png'
import RA from '../../assets/Site_Web/RA.png'

import Nav from '../MEP/SWNav'
import FooterSW from '../MEP/footer_SW';
import CarrousselLogo from "./composants_accueil/carrousselPartenaires";
import Methode3Etapes from "./composants_accueil/Methode3Etapes";

function Accueil() {

  const [goToLocalisation, setGoToLocalisation] = useState(false)
  const [goToProjets, setgoToProjets] = useState(false)
  const [goToContact, setGoToContact] = useState(false)
  const [goToDiag, setgoToDiag] = useState(false)


  function handleContacter(event){
    event.preventDefault()
    setGoToContact(true)
  }
  function handleSubmitLoca(event) {
    event.preventDefault()
    setGoToLocalisation(true)
  }
  function handleClickProjets(event) {
    event.preventDefault()
    setgoToProjets(true)
}
function handleClickDC(event) {
  event.preventDefault()
  setgoToDiag(true)
}

  if(goToLocalisation) {
      return <Navigate push to={`/decouvrirDiagoRisk`} />
  }
  if(goToProjets) {
    return <Navigate push to={`/projets`} />
  }
  if(goToContact) {
    return <Navigate push to={`/nouscontacter`} />
  }
  if(goToDiag) {
    return <Navigate push to={`/diagnostics_climatiques`} />
  }

  return (
    <div>
      <Nav/>
      <div className="accueil" >          
        <div className='PremierBlocAccueil'>

          {/* COLONNE GAUCHE */}
          <div className="PremierBlocAccueil__left">
            <img src={logo} alt="DiagoRisk" className="PremierBlocAccueil__logo" />

            <p className='paragrapheAccueil' style={{fontWeight:'bold', marginBottom:'0px'}}>
              Dérisquer les transitions agricoles
            </p>

            <p className="paragrapheLanding">
              DiagoRisk chiffre les impacts des transitions climatiques
              et agroécologiques, vous aide à identifier les solutions les
              plus efficaces aujourd'hui et 2035 – 2050 sur votre
              exploitation et votre territoire.
            </p>

            <div className="PremierBlocAccueil__buttons">
              <a onClick={handleContacter} className="validation validationAccueil2 button_premier_bloc_acc buttonConnexionNav" style={{marginTop:'0px'}}>
                Demander un diagnostic →
              </a>
              <a onClick={handleClickDC} className="PremierBlocAccueil__btn PremierBlocAccueil__btn--secondary ">
                Découvrir nos diagnostics
              </a>
            </div>
          </div>

          {/* COLONNE DROITE — image avec fondu sur la gauche */}
          <div className="PremierBlocAccueil__right">
            <img src={entete_accueil} alt="Agriculture" className="PremierBlocAccueil__img" />
          </div>
        </div>
      

        <div className='column'>
           <Methode3Etapes />

          <div className='paragrapheAccueil' style={{fontWeight:'bold', textAlign:'center', color:'#57802B', marginTop:'20px'}}> Ils nous font confiance</div>

          <CarrousselLogo />

          <div className='cardAccueil'>
            <div className='cardAccueil2 accueilCardFloat' >
              <div className='cardAccueil2' style={{width:'100%'}}>
                <img src={vitiPlus2} alt="champs de cultures céréalières" className="imgcardaccueil2 imgduoaccuel"/>
                <div className='paragrapheAccueil imgcardaccueil2' style={{fontWeight:'bold', textAlign:'center', marginTop:'10px',color:'#57802B'}}>Réalisez vos diagnostics Climat facilement grâce à DiagoRisk </div>
                <div className='paragraphe paragrapheLanding imgcardaccueil2 prghduoaccueil'>A l’échelle de votre territoire ou de votre exploitation, nous vous accompagnons dans l’élaboration de votre stratégie collective d’adaptation au changement climatique. </div>
              </div>
              <button className='validation validationAccueil2 buttonConnexionNav boutonCoinDroit' style={{width:'10%', lineHeight:'2'}} onClick={handleClickDC} > {">"} </button>
            </div>
            <div className='cardAccueil2 accueilCardFloat' >
              <div className='cardAccueil2' style={{width:'100%'}}>
                <img src={secutransi} alt="chemin agricole" className="imgcardaccueil2 imgduoaccuel"/>
                <div className='paragrapheAccueil imgcardaccueil2' style={{fontWeight:'bold', textAlign:'center', marginTop:'10px',color:'#57802B'}}> Sécurisez vos transitions </div>
                <div className='paragraphe paragrapheLanding imgcardaccueil2 prghduoaccueil' style={{marginBottom:'1%'}}>Nous vous aidons à dérisquer les nouvelles pratiques agricoles pour accélérer leur adoption à grande échelle.</div>
              </div>  
              <button className='validation validationAccueil2 buttonConnexionNav boutonCoinDroit' style={{width:'10%', lineHeight:'2'}} onClick={handleClickProjets}>{">"}</button>
            </div>
          </div>

          

          <div className='cardAccueil3' style={{marginTop:'2%', marginBottom:'2%'}}>
            <img src={RA} alt="Carte des région agricole" className="imageAccueil"/>
            <div className='textCardAccueil textCardAccueil2' style={{marginLeft:'5%'}}>
              <div className='paragraphe paragrapheLanding' style={{marginBottom:'2%'}}> Notre ambition est de dérisquer les nouvelles pratiques agricoles pour accélérer leur adoption à grande échelle. </div>
              <div className='paragraphe paragrapheLanding'> Cette solution s’appuie sur une modélisation puissante des risques rendement, des projections du GIEC et des bioagresseurs, développée par une équipe de spécialistes du risque agricole, du changement climatique et de l’assurance, en partenariat avec l’Institut du Risque et de l’Assurance de l’Université du Mans. </div>
              <button className='validation validationAccueil2 buttonConnexionNav' onClick={handleContacter}>Contactez-nous</button>
            </div>
          </div>

        </div>
      </div>
      <FooterSW/>
    </div>
  );
}

export default Accueil;

